import React from "react";
import "./errorDialog.scss"

/**
 * 
 * @param {string} text Texto del error que se renderizará
 * @description Renderiza un texto de error. 
 * Está siendo utilizado tanto para renderizar 
 * algunos errores de formulario como 
 * para renderizar errores de servidor 
 */

const ErrorDialog = ({ text }) => {
  const defaultText =
    "Se ha producido un error. Vuelve a intentarlo más tarde.";

  return (
    <p className="form-error">{text ?? defaultText}</p>
  );
};

export default ErrorDialog;
